import styled from "styled-components";
import { Select, Radio, Col } from "antd";

import * as Layout from "common/layout";
import { SectionTitle } from "common/text";

const { PageContent, PageSection } = Layout;

type BannerSectionProps = {
  "background-url": string;
};

export const BannerSection = styled(PageSection)`
  background-color: #1070b6;
  background-image: ${(props: BannerSectionProps) =>
    props["background-url"] ? `url(${props["background-url"]})` : ""};
  background-repeat: repeat;
`;

export const ContentSection = styled(PageContent)`
  margin-top: 0;
`;
export const CourseBannerTitle = styled(SectionTitle)`
  color: white;
`;

export const StyledFilter = styled(Radio.Group)`
  display: flex;
  flex-direction: row;
  border: none;
  height: 36px;

  & .ant-radio-button-wrapper {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: #707070;
    padding: 0px 12px;
    border: none;
    width: 100%;
    @media (min-width: 990px) {
      @media (max-width: 1105px) {
        padding: 0px;
      }
    }
  }
  & .ant-layout-content {
    flex: none;
  }
  & .ant-radio-button-wrapper:hover {
    color: #707070;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover::before {
    background-color: transparent;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    background-color: transparent;
  }
  .ant-radio-button-wrapper:not(:first-child)::before {
    width: 0px;
  }

  & .ant-radio-button-wrapper-checked {
    background-color: #1070b6;
    color: #fff;
    border: none;
  }

  & .ant-radio-button-wrapper-checked * {
    border: none;
  }
  .ant-layout-content {
    margin-top: 0px;
  }
`;

export const SelectorContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const SelectorLabel = styled(Col)`
  display: flex;
  font-size: 16px;
  color: white;
  font-weight: bold;
  align-items: center;
  margin-right: 4px;
  text-align: left;
`;

export const StyledSelector = styled(Select)`
  height: 36px;
  font-size: 15px;
  color: black;
  width: 160px;
  flex-grow: 1;

  &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 100%;
    background-color: #ffffff;
    justify-content: center;
    text-align: left;
    display: flex;
    align-items: center;
    padding: 0px 16px;
  }

  &.ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector::placeholder {
    color: #707070;
  }

  & .ant-select-arrow {
    margin-right: 8px;
  }

  &.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
    justify-content: center;
    display: flex;
    align-items: center;
  }
`;

export const CourseDetails = styled.div`
  text-align: left;
  color: #707070;
  span.detail {
    display: block;
  }

  @media (min-width: 420px) {
    span.detail {
      display: inline;
    }
    span.detail:after {
      content: "|";
      color: #707070;
      padding: 10px;
    }
  }
`;
